import { useState, useEffect } from 'react';
import { api } from '../lib/api';
import { Users, Plus, Edit2 } from 'lucide-react';

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ username: '', password: '', full_name: '', role: 'salesman', commission_rate: 0.10, manager_id: '', manager_cut: 0 });

  const load = () => { api.get('/users').then(setUsers); };
  useEffect(load, []);

  const set = (f) => (e) => setForm(prev => ({ ...prev, [f]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form, commission_rate: Number(form.commission_rate), manager_cut: Number(form.manager_cut) || 0, manager_id: Number(form.manager_id) || null };
    if (editing) {
      await api.put(`/users/${editing}`, { ...payload, active: 1 });
    } else {
      await api.post('/users', payload);
    }
    setShowForm(false);
    setEditing(null);
    setForm({ username: '', password: '', full_name: '', role: 'salesman', commission_rate: 0.10, manager_id: '', manager_cut: 0 });
    load();
  };

  const startEdit = (u) => {
    setEditing(u.id);
    setForm({ username: u.username, password: '', full_name: u.full_name, role: u.role, commission_rate: u.commission_rate, manager_id: u.manager_id || '', manager_cut: u.manager_cut || 0 });
    setShowForm(true);
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold flex items-center gap-2"><Users className="w-6 h-6" /> Team</h1>
        <button onClick={() => { setShowForm(true); setEditing(null); }}
          className="bg-nova-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-nova-700 flex items-center gap-2">
          <Plus className="w-4 h-4" /> Add User
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} className="bg-white rounded-xl border p-5 mb-4">
          <h2 className="font-semibold mb-3">{editing ? 'Edit User' : 'New User'}</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            <input className="px-3 py-2 border rounded-lg text-sm" placeholder="Username" value={form.username} onChange={set('username')} required />
            <input type="password" className="px-3 py-2 border rounded-lg text-sm" placeholder={editing ? 'New password (optional)' : 'Password'} value={form.password} onChange={set('password')} required={!editing} />
            <input className="px-3 py-2 border rounded-lg text-sm" placeholder="Full Name" value={form.full_name} onChange={set('full_name')} required />
            <select className="px-3 py-2 border rounded-lg text-sm" value={form.role} onChange={set('role')}>
              <option value="salesman">Salesman</option>
              <option value="admin">Admin</option>
            </select>
            <input type="number" step="0.01" className="px-3 py-2 border rounded-lg text-sm" placeholder="Commission Rate" value={form.commission_rate} onChange={set('commission_rate')} />
            <select className="px-3 py-2 border rounded-lg text-sm" value={form.manager_id} onChange={set('manager_id')}>
              <option value="">No Manager</option>
              {users.filter(u => u.id !== editing).map(u => <option key={u.id} value={u.id}>{u.full_name}</option>)}
            </select>
            <input type="number" step="0.01" className="px-3 py-2 border rounded-lg text-sm" placeholder="Manager Cut" value={form.manager_cut} onChange={set('manager_cut')} />
            <div className="flex gap-2">
              <button type="submit" className="flex-1 bg-nova-600 text-white rounded-lg text-sm hover:bg-nova-700">Save</button>
              <button type="button" onClick={() => { setShowForm(false); setEditing(null); }} className="px-3 border rounded-lg text-sm">Cancel</button>
            </div>
          </div>
        </form>
      )}

      <div className="bg-white rounded-xl border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Name</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Username</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Role</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Commission</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Manager</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {users.map(u => (
              <tr key={u.id} className="hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{u.full_name}</td>
                <td className="px-4 py-3 text-gray-500">{u.username}</td>
                <td className="px-4 py-3 capitalize">{u.role}</td>
                <td className="px-4 py-3">{(u.commission_rate * 100).toFixed(0)}%</td>
                <td className="px-4 py-3 text-gray-500">{u.manager_name || '-'}{u.manager_cut > 0 ? ` (${(u.manager_cut * 100).toFixed(0)}% cut)` : ''}</td>
                <td className="px-4 py-3">
                  <button onClick={() => startEdit(u)} className="text-nova-600 hover:underline text-sm flex items-center gap-1">
                    <Edit2 className="w-3 h-3" /> Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
